// Audio system for Space Invaders
export class AudioManager {
  constructor() {
    this.audioCtx = null;
    this.muted = false;
    this.backgroundMusic = null;
    this.backgroundAudio = null;
    this.init();
  }

  init() {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    try { 
      this.audioCtx = new AudioCtx();
    } catch (e) {
      console.warn('WebAudio not supported');
    }
  }

  toggleMute() {
    this.muted = !this.muted;
    // Ingen bakgrunnsmusikk å håndtere
    return this.muted;
  }

  beep(freq = 200, type = 'sine', duration = 0.12, gain = 0.06) {
    if (this.muted || !this.audioCtx) return;
    
    try {
      const o = this.audioCtx.createOscillator();
      const g = this.audioCtx.createGain();
      o.type = type;
      o.frequency.value = freq;
      g.gain.value = gain;
      o.connect(g);
      g.connect(this.audioCtx.destination);
      o.start();
      g.gain.exponentialRampToValueAtTime(0.0001, this.audioCtx.currentTime + duration);
      setTimeout(() => o.stop(), duration * 1000 + 50);
    } catch (e) {
      // ignore on unsupported
    }
  }

  // Predefined sound effects
  shoot() {
    this.beep(880, 'sawtooth', 0.07, 0.07);
  }

  enemyHit() {
    this.beep(420 + Math.random() * 150, 'sine', 0.06, 0.06);
  }

  enemyShoot() {
    this.beep(120 + Math.random() * 80, 'square', 0.05, 0.04);
  }

  playerHit() {
    if (this.muted) return;
    // Dramatisk lydeffekt når man mister liv
    this.beep(150, 'sawtooth', 0.2, 0.4); // Lavere tone, lengre varighet
    setTimeout(() => {
      if (!this.muted) this.beep(100, 'sawtooth', 0.15, 0.3); // Enda lavere tone
    }, 100);
    setTimeout(() => {
      if (!this.muted) this.beep(80, 'sawtooth', 0.1, 0.2); // Laveste tone
    }, 200);
  }

  barrierHit() {
    this.beep(600, 'square', 0.04, 0.03);
  }

  enemyBarrierHit() {
    this.beep(200, 'square', 0.03, 0.03);
  }

  levelComplete() {
    this.beep(660, 'triangle', 0.12, 0.08);
  }

  gameOver() {
    this.beep(80, 'sine', 0.5, 0.12);
    // Ingen bakgrunnsmusikk å stoppe
  }

  startGame() {
    this.beep(440, 'sine', 0.08, 0.07);
    // Ingen bakgrunnsmusikk
  }

  // Bakgrunnsmusikk fra MP3-fil
  async startBackgroundMusic() {
    if (this.muted) return;
    
    try {
      console.log('Starter bakgrunnsmusikk...');
      
      // Sjekk om lyd er tillatt
      if (document.visibilityState === 'hidden') {
        console.log('Side er ikke synlig, venter med musikk...');
        return;
      }
      
      // Opprett HTML5 Audio element
      this.backgroundAudio = new Audio('./src/assets/audio/background-music.mp3');
      
      // Legg til event listeners for debugging
      this.backgroundAudio.addEventListener('loadstart', () => console.log('Musikk: loadstart'));
      this.backgroundAudio.addEventListener('canplay', () => console.log('Musikk: canplay'));
      this.backgroundAudio.addEventListener('playing', () => console.log('Musikk: playing'));
      this.backgroundAudio.addEventListener('error', (e) => console.error('Musikk error:', e));
      
      this.backgroundAudio.loop = true;
      this.backgroundAudio.volume = 0.025; // Enda lavere volum
      
      // Fade-in effekt
      this.backgroundAudio.volume = 0;
      await this.backgroundAudio.play();
      
      console.log('Musikk startet, volum:', this.backgroundAudio.volume);
      
      // Gradvis fade-in over 3 sekunder
      let volume = 0;
      const targetVolume = 0.025;
      const fadeInterval = setInterval(() => {
        volume += 0.001; // Mindre steg for lavere volum
        if (volume >= targetVolume) {
          volume = targetVolume;
          clearInterval(fadeInterval);
          console.log('Fade-in fullført, volum:', volume);
        }
        this.backgroundAudio.volume = volume;
      }, 30); // 30ms mellom hver oppdatering = 3 sekunder totalt
      
    } catch (e) {
      console.error('Kunne ikke starte bakgrunnsmusikk:', e);
    }
  }

  stopBackgroundMusic() {
    if (this.backgroundAudio) {
      try {
                 // Gradvis fade-out over 2 sekunder
         let volume = this.backgroundAudio.volume;
         const fadeInterval = setInterval(() => {
           volume -= 0.001; // Mindre steg for lavere volum
           if (volume <= 0) {
             volume = 0;
             clearInterval(fadeInterval);
             this.backgroundAudio.pause();
             this.backgroundAudio = null;
           } else {
             this.backgroundAudio.volume = volume;
           }
         }, 20); // 20ms mellom hver oppdatering = 2 sekunder totalt
      } catch (e) {
        console.warn('Kunne ikke stoppe bakgrunnsmusikk:', e);
      }
    }
  }
}
